export const CURRENCIES: {
    [key: string]: string,
} = {
    JPY: 'JPY',
    CNY: 'CNY',
};

/**
 * Returns whether a currency should display large values in **millions** (M)
 * rather than billions (B).
 *
 * Certain currencies (JPY, CNY) have a much higher nominal unit count than
 * USD/EUR, so financial UIs conventionally show their large values at the
 * million scale instead of the billion scale. Pass the ISO 4217 currency code
 * to determine which display mode to use.
 *
 * @param userCurrencyCode - ISO 4217 currency code (e.g. `'JPY'`, `'USD'`).
 * @returns `true` for currencies that use million-scale display (JPY, CNY);
 *   `false` for all others.
 *
 * @example
 * ```ts
 * inMillion('JPY'); // → true
 * inMillion('CNY'); // → true
 * inMillion('USD'); // → false
 * ```
 */
export const inMillion = (userCurrencyCode: string): boolean =>
    [CURRENCIES.JPY, CURRENCIES.CNY].includes(userCurrencyCode);
